//User.ts

import { defineStore } from 'pinia'
import { UserService } from '~/services/UserService'
import {
  UserLoginRequest,
  UserLoginResponse,
  UserRegisterRequest,
  VerifyPhoneRequest,
  ForgotPasswordChangeWithFlagCodeRequest,
  ProfileChangePasswordRequest,
  MeResponse,
  UserProfileInformationsResponse,
  UserProfileInformationUpdateRequest,
  RepeatCodeForVerifyPhoneRequest
} from "~/models/UserModels";

import { useMyNotificationsStore } from '~/stores/notifications';

import { useCookie, useRouter } from 'nuxt/app';

import { profileRoutes } from '~/utils/routes';



export const useMyUserStore = defineStore({
  id: 'myUserStore',
  state: () => ({
    profileRoutes: profileRoutes as Array<{
      id: number;
      route: string;
      text: string;
      icon: string;
    }>,
    codeExpireDate: '' as any,
    userLoginInfo: {} as UserLoginResponse,
    userInfo: {} as UserProfileInformationsResponse,
    me: {} as MeResponse,
    cookie: null as any,
    user: null as string | null,
    tempPhone: null as string | null | any,
    requiredFieldShow: false as boolean | null | any,
    istoken: false,
    token: null as string | null,
    isTokenValid: null as any,
    comeBackPath: false as boolean | null as any,
    returnPath: '' as string,
    isRamsPage: false as boolean,
  }),
  getters: {
    getUserLoginInfo(state) {
      return state.userLoginInfo;
    },
    getUserProfileInformations(state) {
      return state.userInfo;
    },
    getUserFullName(state) {
      if (state.me.firstName && state.me.lastName) {
        return state.me.firstName + " " + state.me.lastName;
      }
      else {
        return false;
      }
    },
    getProfileRoutes(state) {
      return state.profileRoutes;
    },
    getMe(state) {
      return state.me;
    },
    getCodeExpireDate(state) {
      return state.codeExpireDate;
    },
    getTempPhone(state) {
      return state.tempPhone;
    },
    getRequiredFieldShow(state) {
      return state.requiredFieldShow;
    },
    getIsToken(state) {
      return state.istoken;
    },
    getToken(state) {
      return state.token;
    },
    getIsTokenValid(state) {
      return state.isTokenValid;
    },
    getComeBack(state) {
      return state.comeBackPath;
    },
    getIsRamsPage(state){
      return state.isRamsPage
    }
  },
  actions: {
    initializeCookie() {
      if (typeof window !== "undefined") {
        this.cookie = useCookie('cookiesAccepted').value || null;
      }
    },
    initializeState() {
      if (typeof window !== "undefined") {
        this.token = localStorage.getItem("token") || null;
        this.isTokenValid = localStorage.getItem("isTokenValid") === "false" ? false : null;
      }
    },
    setRequiredFieldShow(newVal: boolean) {
      this.requiredFieldShow = newVal;
    },

    async Login(body: UserLoginRequest): Promise<boolean> {
      const userService = new UserService();
      try {
        await userService.Login(body).then((res) => {
          if (res.data.isSuccess) {
            this.AfterLogin(res)
          }
          else {
            toast.error(res.data.message)
          }
        })
        return true
      }
      catch (error: any) {
        toast.error(error)
        return false
      }
    },
    //google ile giriş yapma
    LoginWithFireBase(body: { idToken: string }) {
      const router = useRouter();
      const userService = new UserService();

      try {
        userService.LoginWithFireBase(body).then((res) => {
          if (res.data.isSuccess) {
            this.AfterLogin(res)
          }
          else {
            toast.error(res.data.message)
          }
        })
      }
      catch (error: any) {
        toast.error(error)
      }
    },
    getCookies() {
      this.cookie = useCookie('cookiesAccepted').value || null;
      return this.cookie;
    },
    async Register(body: UserRegisterRequest): Promise<boolean> {
      const userService = new UserService();

      try {
        return userService.Register(body).then((res) => {
          if (res.data.isSuccess) {
            toast.success("Telefonunuza doğrulama kodu gönderildi.");
            this.codeExpireDate = res.data.data.codeExpireDate;
            localStorage.setItem('session', res.data.data.session);
            return true
          }
          else {
            toast.error(res.data.message)
            return false
          }
        })
      }
      catch (error: any) {
        toast.error(error)
        return false
      }
    },
    async AfterLogin(res: any) {
      const router = useRouter();
      this.userLoginInfo = res.data.data;
      if (res.data.data.token) {
        localStorage.setItem('token', res.data.data.token);
        this.token = res.data.data.token;
      }

      await this.FetchMe();
      await this.FetchUserProfileInformations();
      const notificationsStore = useMyNotificationsStore();
      if (this.token) {
        notificationsStore.setSignalRConnection(this.token);
      }

      try {
        if (this.me?.isBasicInfoCompleted === false) {
          await router.push('/profil/kisisel-bilgilerim');
        }
        else if (this.returnPath) {
          await router.push(this.returnPath);
          this.returnPath = ''; // Clear the return path after use
        }
        else if(this.isRamsPage){
          await router.push('/rams');
        } 
        else {
          await router.push('/yatirimlar');
        }
      } catch (error) {
        console.error('Yönlendirme hatası:', error);
      }
    },
    updateCurrentRamsPage(isRamsPage: boolean) {
      this.isRamsPage = isRamsPage;
    },
    //kayıttan sonra ekrana gelen aktivasyon code girme kısmı
    async VerifyPhone(body: VerifyPhoneRequest): Promise<boolean> {
      const userService = new UserService();

      try {
        const res = await userService.VerifyPhone(body);
        if (res.data.isSuccess) {
          //local storagedeki sessionu siliyoruz
          localStorage.removeItem('session');
          this.codeExpireDate = null;
          return true;
        } else {
          toast.error(res.data.message);
          return false;
        }
      } catch (error: any) {
        toast.error(error);
        return false;
      }
    },


    // telefon numarası için tekrar aktivasyon kodu gönderme
    async RepeatCodeForVerifyPhone(body: RepeatCodeForVerifyPhoneRequest): Promise<boolean> {
      const userService = new UserService();

      try {
        const res = await userService.RepeatCodeForVerifyPhone(body);
        if (res.data.isSuccess) {
          // toast.success(res.data.message);
          this.codeExpireDate = res.data.data.codeExpireDate;
          return true;
        } else {
          toast.error(res.data.message);
          return false;
        }
      } catch (error: any) {
        toast.error(error);
        return false;
      }
    },

    //şifremi unuttum kısmındaki telefon numarası doğrulama
    async ForgotPassword(body: { phone: string }): Promise<boolean> {
      const userService = new UserService();

      try {
        const res = await userService.ForgotPassword(body);
        if (res.data.isSuccess) {
          toast.success("Telefonunuza doğrulama kodu gönderildi.");
          this.codeExpireDate = res.data.data.codeExpireDate;
          localStorage.setItem('session', res.data.data.session);
          return true;
        } else {
          toast.error(res.data.message);
          return false;
        }
      } catch (error: any) {
        toast.error(error);
        return false;
      }
    },
    async ForgotPasswordVerifyPhone(body: { verificationCode: string, phone: string }): Promise<any> {
      const userService = new UserService();

      try {
        const res = await userService.VerifyPhone(body);
        return res;
      } catch (error: any) {
        toast.error(error);
        return false;
      }
    },

    //şifre değiştirme - şifremi unuttum kısmı
    async ForgotPasswordChangeWithFlagCode(body: ForgotPasswordChangeWithFlagCodeRequest): Promise<boolean> {
      const userService = new UserService();

      try {
        const res = await userService.ForgotPasswordChangeWithFlagCode(body);
        if (res.data.isSuccess) {
          toast.success("Şifreniz başarıyla değiştirildi.");
          toast.success("Giriş sayfasına yönlendiriliyorsunuz...");
          return true;
        } else {
          toast.error(res.data.message);
          return false;
        }
      } catch (error: any) {
        toast.error(error);
        return false;
      }
    },

    //profildeki şifre değiştirme

    async ProfileChangePassword(body: ProfileChangePasswordRequest): Promise<boolean> {
      const userService = new UserService();

      try {
        const res = await userService.ProfileChangePassword(body);
        if (res.data.isSuccess) {
          toast.success("Şifreniz başarıyla değiştirildi.");
          return true;
        } else {
          toast.error(res.data.message);
          return false;
        }
      } catch (error: any) {
        toast.error(error);
        return false;
      }
    },

    //çıkış yapma
    async Logout() {
      const userService = new UserService();

      const router = useRouter();
      try {
        const res = await userService.Logout({});
        if (res.data.isSuccess) {
          localStorage.clear();
          this.token = null;
          const useNotificationStore = useMyNotificationsStore();
          useNotificationStore.endSignalRConnection();
          if(this.isRamsPage){
            await router.push('/rams');
          } 
          else {
            router.push('/giris-yap');
          }
          this.resetState();
        } else {
          toast.error(res.data.message);
        }
      } catch (error: any) {
        toast.error(error);
      }
    },

    //kullanıcı bilgilerini getirme
    async FetchUserProfileInformations() {
      const userService = new UserService();
      const router = useRouter();
      try {
        if (this.istoken) {
          const res = await userService.Profile();
          if (res.data.isSuccess === true) {
            this.userInfo = res.data.data;
            this.updateUserInfo(res.data.data);
            return true;
          } else {
            toast.error(res.data.message);
            return false;
          }
        } else {

        }

      } catch (error: any) {
        toast.error(error);
        return false;
      }
    },

    //me bilgilerini getirme
    async FetchMe() {
      const userService = new UserService();
      return new Promise((resolve, reject) => {
        userService.Me()
          .then(res => {
            if (res.data.isSuccess === true) {
              this.me = res.data.data;
              this.userInfo = res.data.data;
              this.updateIsToken(true);
              resolve(res.data.data);
            } else {
              localStorage.clear();
              this.updateIsToken(false);
              resolve(false);
            }
          })
          .catch(error => {
            toast.error(error);
            reject(error);
          });
      });
    },


    //kullanıcı bilgilerini güncelleme
    async UpdateProfile(body: UserProfileInformationUpdateRequest): Promise<any> {
      const userService = new UserService();

      try {
        const res = await userService.UpdateProfile(body);
        this.tempPhone = body.phone;
        if (res.data.isSuccess) {
          // this.FetchUserProfileInformations();
          this.FetchMe();
          this.FetchUserProfileInformations()
          this.codeExpireDate = res.data.data.codeExpireDate;

          if (res.data.data.isPhoneChanged == true) {
            localStorage.setItem('session', res.data.data.session);
          }
          return res;
        } else {
          toast.error(res.data.message);
          return false;
        }
      } catch (error: any) {
        toast.error(error);
        return false;
      }
    },

    //hesabımı dondurma
    async DeleteAccount() {
      const router = useRouter();
      const userService = new UserService();
      const res = await userService.DeleteAccount();
      if (res.data.isSuccess) {
        toast.success("Hesabınız başarıyla donduruldu");
        localStorage.clear();
        this.token = null;
        const useNotificationStore = useMyNotificationsStore();
        useNotificationStore.endSignalRConnection();
        router.push('/giris-yap');
      } else {
        toast.error(res.data.message);
      }
    },
    //recaptcha v3 token kontrolü
    async RecaptchaV3Verify(token: string | undefined) {
      const userService = new UserService();

      if (token) {
        try {
          const res = await userService.RecaptchaV3Verify({ token: token });
          if (res.data.isSuccess) {
          } else {
            toast.error(res.data.message);
          }
        } catch (error: any) {
          toast.error("RecaptchaV3Verify işlemi başarısız");
        }
      }
      else {
        toast.error("Recaptcha token bulunamadı")
      }

    },

    resetState() {
      this.userInfo = {} as UserProfileInformationsResponse;
      this.me = {} as MeResponse;
      this.userLoginInfo = {} as UserLoginResponse;
      this.token = null;
      this.istoken = false;
    },

    setUser(user: string) {
      this.user = user;
      useCookie('user').value = user;
    },

    getUser() {
      this.user = useCookie('user').value || null;
    },
    updateUserInfo(userInfo: UserProfileInformationsResponse) {
      this.userInfo = userInfo;
    },
    updateIsToken(token: boolean) {
      this.istoken = token
    },
    setIsTokenValid(isValid: boolean | null) {
      this.isTokenValid = isValid;
      if (isValid !== null) {
        localStorage.setItem("isTokenValid", isValid ? "true" : "false");
      } else {
        localStorage.removeItem("isTokenValid");
      }
    },
    setToken(token: string | null) {
      this.token = token;
      if (token) {
        localStorage.setItem("token", token);
      } else {
        localStorage.removeItem("token");
      }
    },
    updateComeBack(path: boolean | null | String) {
      this.comeBackPath = path
    },
 
    updateReturnPath(path: string) {
      this.returnPath = path;
    },
  }
})
